
import './SectionPlaceholder.css';

export const SectionPlaceholder = ({ part, enablingAction, image, title, subTitle }) => {
    return (
        <div className='section-placeholder-compoennt'>
            {image && <img style={{height: "50%"
            }} src={image} />}
            {title && <b>{title}</b>}
            {subTitle && <i>{subTitle}</i>}
        </div>
    )
}